export default "__VITE_ASSET__H9B9dDIF__"